export const PrimaryAction = ({ children, onClick, disabled, accent, testId, iconRight: IconRight }) => (
    <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className="inline-flex items-center gap-2 h-10 px-5 rounded-md text-[13px] font-semibold text-white disabled:opacity-40 disabled:cursor-not-allowed transition-all hover:opacity-95 active:scale-[0.98]"
        style={{ background: accent }}
        data-testid={testId}
    >
        {children}
        {IconRight && <IconRight className="h-[18px] w-[18px]" strokeWidth={2} />}
    </button>
);
